import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TipoCredencial, TipoProvedor } from '../../../types/smartinteg';
import { TIPOS_BANCO_DADOS, editandoCredencial, opcoesCredencial, rotuloCredencial } from './conexao-form.util';

// Campos de uma conexão (identificação, configuração de API/banco e credencial), usados pelo
// "criar provedor completo" e pelo diálogo de Conexões. O FormGroup e as regras vêm do pai
// (ver conexao-form.util.ts).
@Component({
  selector: 'app-conexao-campos',
  templateUrl: './conexao-campos.component.html',
  styleUrl: './conexao-campos.component.css'
})
export class ConexaoCamposComponent {
  @Input({ required: true }) form!: FormGroup;
  @Input({ required: true }) tipoProvedor!: TipoProvedor;
  @Input() modoEdicao: boolean = false;
  @Input() tipoCredencialAtual: TipoCredencial | null = null;

  TipoCredencial = TipoCredencial;
  tiposBancoDados = TIPOS_BANCO_DADOS;

  get api(): boolean {
    return this.tipoProvedor === TipoProvedor.APIREST;
  }

  get opcoesCredencial() {
    return opcoesCredencial(this.tipoProvedor);
  }

  get tipoCredencialForm(): TipoCredencial {
    return this.form.get('tipoCredencial')?.value;
  }

  get rotuloCredencialAtual(): string {
    return rotuloCredencial(this.tipoCredencialAtual);
  }

  // Na criação o editor de credencial é sempre exibido; na edição, só se o usuário optar por alterá-la
  get editorCredencialVisivel(): boolean {
    return editandoCredencial(this.form, this.modoEdicao);
  }

  campoInvalido(campo: string): boolean {
    const control = this.form.get(campo);
    return !!(control && control.invalid && control.touched);
  }
}
